import { Inline, Shape, ThemingContext } from '@doordash/design-language';
import { InputConnectedWrapper, InputContainer, InputContentContainer, InputRoot } from './styles';
import { SizeSemantics, Sizes } from './constants';
import PropTypes from 'prop-types';
import React from 'react';
import { getThemeFieldTextStyles } from '../utils';
var INLINE_MARGIN = Inline.Sizes.XxSmall;

var InputWrapper = function InputWrapper(_ref) {
  var isBare = _ref.isBare,
      isDisabled = _ref.isDisabled,
      isAdjustableHeight = _ref.isAdjustableHeight,
      isRounded = _ref.isRounded,
      error = _ref.error,
      hasConnectedContentAbove = _ref.hasConnectedContentAbove,
      hasConnectedContentBelow = _ref.hasConnectedContentBelow,
      renderBeforeContent = _ref.renderBeforeContent,
      renderAfterContent = _ref.renderAfterContent,
      renderConnectedBefore = _ref.renderConnectedBefore,
      renderConnectedAfter = _ref.renderConnectedAfter,
      children = _ref.children,
      size = _ref.size,
      hasDefaultRenderContent = _ref.hasDefaultRenderContent;
  var theme = React.useContext(ThemingContext);
  var inputTextStyles = getThemeFieldTextStyles({
    theme: theme,
    size: size,
    styleType: 'Input'
  });
  return /*#__PURE__*/React.createElement(InputRoot, {
    themeHeight: theme.Size[SizeSemantics[size]]
  }, renderConnectedBefore && /*#__PURE__*/React.createElement(InputConnectedWrapper, {
    side: "left",
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    isRounded: isRounded
  }, renderConnectedBefore()), /*#__PURE__*/React.createElement(InputContainer, {
    size: size,
    error: error,
    disabled: isDisabled,
    isBare: isBare,
    roundedLeft: !!!renderConnectedBefore,
    roundedRight: !!!renderConnectedAfter,
    roundedAbove: !hasConnectedContentAbove,
    roundedBelow: !hasConnectedContentBelow,
    isRounded: isRounded || theme.Shape.Field === Shape.Pill,
    isAdjustableHeight: isAdjustableHeight,
    renderVerticalPadding: isAdjustableHeight || !!renderBeforeContent || !!renderAfterContent,
    leadingRenderContent: !!renderBeforeContent,
    trailingRenderContent: !!renderAfterContent,
    mobileInputTextStyles: inputTextStyles.mobile,
    desktopInputTextStyles: inputTextStyles.desktop,
    hasDefaultRenderContent: hasDefaultRenderContent
  }, renderBeforeContent && /*#__PURE__*/React.createElement(Inline, {
    size: INLINE_MARGIN
  }, renderBeforeContent()), /*#__PURE__*/React.createElement(InputContentContainer, {
    isAdjustableHeight: isAdjustableHeight,
    hasTrailingRenderContent: !!renderAfterContent
  }, children), renderAfterContent && /*#__PURE__*/React.createElement(Inline, {
    size: Inline.Sizes.None
  }, renderAfterContent())), renderConnectedAfter && /*#__PURE__*/React.createElement(InputConnectedWrapper, {
    side: "right",
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    isRounded: isRounded
  }, renderConnectedAfter()));
};

InputWrapper.Sizes = Sizes;
InputWrapper.propTypes = {
  isBare: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isAdjustableHeight: PropTypes.bool,
  isRounded: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hasConnectedContentBelow: PropTypes.bool,
  hasConnectedContentAbove: PropTypes.bool,
  renderBeforeContent: PropTypes.func,
  renderAfterContent: PropTypes.func,
  renderConnectedBefore: PropTypes.func,
  renderConnectedAfter: PropTypes.func,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.values(Sizes)),
  hasDefaultRenderContent: PropTypes.bool
};
export default InputWrapper;